// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

// Newly added generic nested form controller
import NestedFormController from "./nested-form_controller"
application.register("nested-form", NestedFormController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import ContractFormController from "./contract-form_controller"
application.register("contract-form", ContractFormController)

import ConsultingProjectFormController from "./consulting-project-form_controller"
application.register("consulting-project-form", ConsultingProjectFormController)

import TimesheetFormController from "./timesheet-form_controller"
application.register("timesheet-form", TimesheetFormController)
